// extracted by mini-css-extract-plugin
export var settingsList = "_39-0";
export var settingsRow = "_39-1";
export var warningDot = "_39-2";